export const UNKNOWN = 'UNKNOWN';
export const NOBODY = 'NOBODY';
